import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import CustomLink from '@shared/components/customLink'
import MyImage from '@shared/components/myImage'
import { getImgURL } from '@shared-submodule/utils'
import useWindowSize from '@shared/hooks/windowSize'
import { PointerRight } from '@shared/components/ctIcons'

const HighlightArticle = ({ article, isChess = false }) => {
  // const article = data?.aResults?.[0]
  const [width] = useWindowSize()

  return (
    <>
      <div className={`container mb-4 ${styles.highlight}`}>
        <div className="row cursor-pointer">
          <div className="widget-title  d-flex justify-content-between align-items-center">
            <h3 className="small-head d-flex align-items-center  mb-0">
              <span>Spotlight piece</span>
            </h3>
          </div>
          <div className={`${styles.highlight_content}`}>
            {article && (
              <CustomLink href={article?.oSeo?.sSlug}>
                <div className={`row ${styles.data}`}>
                  <div className={` col-7 ${styles.img}`}>
                    <MyImage
                      src={getImgURL(article?.oImg?.sUrl)}
                      alt={article.sSrtTitle}
                      width={800}
                      height={400}
                      className={`${styles.highlight_img}`}
                    />
                  </div>
                  <div className={`col-5 ${styles.highlight_text}`}>
                    <div className={styles.highlightHeading} style={{ lineHeight: '45px', marginTop: '6px' }}>
                      {article.sSrtTitle}
                    </div>
                    <p className={styles.info}>{article.sDescription.slice(0, 126)}...</p>

                    {width > 950 ? (
                      <button className={`${styles.btn}`}>View More →</button>
                    ) : (
                      !isChess && (
                        <div className={styles.titleMascotLink}>
                          <a>View More</a>
                          <span className="ms-2">
                            <PointerRight />
                          </span>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </CustomLink>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

HighlightArticle.propTypes = {
  article: PropTypes.object.isRequired,
  isChess: PropTypes.bool
}

export default HighlightArticle
